'use client';

import React from 'react';

import styled from 'styled-components';

import { FiltersProvider } from '@contexts/Filters';
import {
  CampaignBannerViewModel,
  ListingBannerViewModel,
  ListingNotFoundContentsViewModel,
  SearchViewModel,
} from '@api/v3';
import {
  ResourceIdProvider,
  SearchURLProvider,
  SsrDataProvider,
} from '@api/data-loaders/resource';
import { IsKocAliemValidatedProvider } from '@contexts/loyalty/KocAilem';

import TourListing from './TourListing';

const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  overflow: hidden;
`;
interface TourListingScreenProps {
  resourceType?: string;
  metaInfo?: Record<string, string>;
  bannerInfo?: ListingBannerViewModel | undefined;
  data: any;
  campaignBanners?: CampaignBannerViewModel;
  initialData?: any;
  popularSearchData?: ListingNotFoundContentsViewModel;
  initialSearchesUrl: SearchViewModel;
}

const TourListingScreen = ({
  resourceType = 'Tur',
  metaInfo,
  bannerInfo,
  data,
  campaignBanners,
  initialData,
  popularSearchData,
  initialSearchesUrl,
}: TourListingScreenProps) => {
  const resource = /cruise/gi.test(resourceType) ? 'Gemi' : 'Tur';
  return (
    <Container>
      <ResourceIdProvider value={data?.props?.resourceKey}>
        <SsrDataProvider value={data}>
          <SearchURLProvider value={data?.props?.urlSearch}>
            <IsKocAliemValidatedProvider>
              <FiltersProvider>
                <TourListing
                  resource={resource}
                  metaInfo={metaInfo}
                  bannerInfo={bannerInfo}
                  campaignBanner={campaignBanners}
                  initialData={initialData}
                  popularSearchData={popularSearchData}
                  initialSearchesUrl={initialSearchesUrl}
                />
              </FiltersProvider>
            </IsKocAliemValidatedProvider>
          </SearchURLProvider>
        </SsrDataProvider>
      </ResourceIdProvider>
    </Container>
  );
};

export default TourListingScreen;
